import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'percentage',
})
export class PercentagePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: any, decimals?: number): any {
    /*jshint maxcomplexity:6 */
    let parsedReturnValue
    if (isNaN(parseInt(value, 10))) {
      return '—'
    }
    if (!decimals) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      decimals = 2
    }
    parsedReturnValue = parseFloat(value)
    // eslint-disable-next-line prefer-const
    const zeroString = '-' + parseFloat('0').toFixed(decimals)
    parsedReturnValue = parseFloat(parsedReturnValue).toFixed(decimals)
    // To handel -0.xx. Return positive Zero.
    if (parsedReturnValue === zeroString) {
      parsedReturnValue = parseFloat('0').toFixed(decimals)
    }
    return parsedReturnValue + '%'
  }
}
